// Production
// export const IP = "54.169.139.29";
export const IP = "chatbot.redseamall.com";

// Production default is unchanged. Set REACT_APP_API_URL to point a local dev
// build at a local backend, e.g.
//   REACT_APP_API_URL=http://127.0.0.1:8010/api npm start
export const localurl = process.env.REACT_APP_API_URL || `https://${IP}/api`;
